import { NEW_COLLECTION_ID, CATALOG_DATA_TYPE } from 'modules/catalog/catalogConstants';

/**
 * checkIfExistingCollection
 * helper function that validates whether it is an existing collection
 *  */
export const checkIfExistingCollection = (id) => id && id !== NEW_COLLECTION_ID;

/**
 * handleSaveQueryValidation
 * helper function fired when handleSaveQuery is called
 */
export const handleSaveQueryValidation = ({
  createCollection,
  id,
  updateCollection,
  validateQuery,
}) => {
  if (id) {
    validateQuery(updateCollection, id);
  } else {
    validateQuery(createCollection);
  }
};

/**
 * handleOnComponentUpdateCatalogChange
 * helper function fired when componentDidUpdate is called
 */
export const handleOnComponentUpdateCatalogChange = (prevCatalog, catalog, handleChangeCatalog) => {
  if (prevCatalog !== catalog) {
    handleChangeCatalog(catalog, true);
  }
};

/**
 * handleChangeCatalog
 * Callback function when catalog changes. Prevents multiple calls is changing to same catalog.
 */
export const handleChangeCatalog = ({ catalogName, catalog, changeCatalog, initialize }) => {
  if (catalogName !== catalog || initialize) {
    changeCatalog(catalogName, true);
  }
};

/**
 * updateFields
 * helper function fired when componentDidUpdate is called
 */
export const updateFields = ({
  catalogFields,
  changeCurrentFields,
  currentFields,
  updateFieldsForProperty,
}) => {
  const fieldKeys = Object.keys(catalogFields);
  const fieldKeysValue = fieldKeys.join(' ');
  const currentFieldsValue = currentFields.join(' ');

  if (fieldKeysValue !== currentFieldsValue) {
    const fields = fieldKeys.map((key) => ({
      name: key,
      value: key,
      type: catalogFields[key],
    }));
    changeCurrentFields(fieldKeys);
    updateFieldsForProperty(CATALOG_DATA_TYPE, fields);
  }
};
